"use client";

import React from "react";
import { kodeMonoBold } from "@/lib/kodeMonoBold";

type HeadingLevel = "h1" | "h2" | "h3" | "h4" | "h5" | "h6";

interface SectionTitleProps {
  title?: string;
  subtitle?: string;
  as?: HeadingLevel;
  titleClassName?: string;
  subtitleClassName?: string;
  className?: string;
}

export default function SectionTitle({
  title,
  subtitle,
  as: Tag = "h3",
  titleClassName = "",
  subtitleClassName = "",
  className = "",
}: SectionTitleProps): React.ReactElement {
  return (
    <div className={`${kodeMonoBold.variable} ${className}`}>
      <Tag
        className={`text-white text-[26px] sm:text-[30px] font-kode-mono-bold leading-normal ${titleClassName}`}
      >
        {title}
      </Tag>
      {subtitle && (
        <p
          className={`mt-0.5 font-kode-mono text-xs font-medium text-white/50 ${subtitleClassName}`}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
}
